import { useEffect, useState } from 'react';
import { CustomModal } from '../CustomModal';
import { Btn } from '../ui';

interface DeleteLegacyResourceModalProps {
    item: { id: string; title: string } | null;
    isDeleting: boolean;
    onDismiss: () => void;
    onConfirmDelete: () => void;
}

export const DeleteLegacyResourceModal = ({
    item,
    isDeleting,
    onDismiss,
    onConfirmDelete,
}: DeleteLegacyResourceModalProps) => {
    const visible = Boolean(item?.id);
    const [confirmReady, setConfirmReady] = useState(false);

    // Avoid click-through from the trash icon activating Delete as the modal opens.
    useEffect(() => {
        if (!visible) {
            setConfirmReady(false);
            return;
        }
        setConfirmReady(false);
        const timer = window.setTimeout(() => setConfirmReady(true), 400);
        return () => window.clearTimeout(timer);
    }, [visible, item?.id]);

    const itemName = item?.title?.trim() || 'this file';

    return (
        <CustomModal
            onDismiss={onDismiss}
            visible={visible}
            header="Delete file?"
            footer={
                <div className="modal-footer-actions">
                    <Btn
                        variant="secondary-outlined"
                        buttonText="Cancel"
                        buttonDisabled={isDeleting}
                        buttonOnClick={onDismiss}
                    />
                    <Btn
                        variant="danger"
                        buttonText={isDeleting ? 'Deleting...' : 'Delete'}
                        buttonDisabled={isDeleting || !confirmReady}
                        buttonOnClick={onConfirmDelete}
                    />
                </div>
            }
        >
            <p>
                You are about to permanently delete <strong>“{itemName}”</strong>. This will remove the file from storage and the database record. This cannot be undone.
            </p>
        </CustomModal>
    );
};
